if($('.js-bgRellax').length){
	var _rellax = new Rellax('.js-bgRellax', {
		horizontal: false,
	});
}
